module.exports = __webpack_public_path__ + "static/media/20180522-LCS-017-2.2bcf6c57.jpg";